module.exports = __webpack_public_path__ + "static/seres-silk-duvet-4-37b51793c24b2a3b0524525a3a178ada.png";